import Heading from '@zenbusiness/zui/Heading';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import IconTooltip from '#client/components/IconTooltip';
import { REFRESH_AFTER_INSTANT_DEPOSIT } from '#client/constants/eventName';
import useEventListeners from '#client/hooks/useEventListeners';
import useSkeleton from '#client/hooks/useSkeleton';
import useUnitAccount from '#client/hooks/useUnitAccount';

export default function AvailableBalance() {
  const {
    loading: loadingUnitAccount,
    unitAccount,
    error: errorUnitAccount,
    refetch: refetchUnitAccount
  } = useUnitAccount();

  const availableBalance = unitAccount?.availableBalance?.formattedAmount ?? '$0.00';

  const isHideSkeleton = errorUnitAccount || (unitAccount && !loadingUnitAccount);
  const [showSkeleton] = useSkeleton(isHideSkeleton);

  useEventListeners([
    {
      eventName: REFRESH_AFTER_INSTANT_DEPOSIT,
      eventHandler: refetchUnitAccount
    }
  ]);
  const balanceText = showSkeleton ? (
    <Skeleton
      aria-label="Loading available balance"
      width="50%"
    />
  ) : (
    `${availableBalance}`
  );

  return (
    <Stack gap={{ xs: '4px', md: '8px' }}>
      <Heading
        aria-label="Available balance"
        family="secondary"
        size="5xl"
        weight="bold"
      >
        {balanceText}
      </Heading>
      <Stack
        alignItems="center"
        direction="row"
        gap="4px"
      >
        <Text
          color="tertiary"
          size="xs"
        >
          Available balance
        </Text>
        <IconTooltip content="This is your account balance, minus any pending authorized transactions." />
      </Stack>
    </Stack>
  );
}
